module.exports = __webpack_public_path__ + "media/Video 69.d93c5268.mp4";